<template>
  <div class="tokenList">
    <!-- 市场价 -->
    <div class="tokenList_tabs">

      <!-- <a-icon type="more" class="more" @click="checkTab"/> -->
    <a-dropdown-button @click="handleButtonClick"  placement="bottomLeft" >
      <a-menu slot="overlay" @click="handleMenuClick" overlayClassName="styleDropdown">
        <a-menu-item v-for="item in quoteAssetList" :key="item.quoteAsset">{{item.quoteAsset}}</a-menu-item>
      </a-menu>
    </a-dropdown-button>
      
      <a-tabs
        :activeKey="activeKey"
        :tabBarStyle="{ borderBottom: 'unset' }"
        @change="checkTrade"
      >
        <a-tab-pane v-for="i in quoteAssetList" :key="i.quoteAsset" :tab="i.quoteAsset"></a-tab-pane>
      </a-tabs>
    </div>

    <div class="tokenList_searchBox">
      <a-input ref="userNameInput" type="text" v-model.trim="searchInfo" :placeholder="$t('12923')" allow-clear @change="onSearch">
        <a-icon slot="prefix" type="search" />
      </a-input>
    </div>

    <div class="tokenList_tHeader"> 
      <div class="tokenList_sortItem " v-for="(i,idx) in listHeader" :key="i.id"  @click="changeSort(i.id)">
        <div class="tokenList_sortItemLabel " v-if="idx===0">
          {{$t('12924')}}
        </div>
        <div class="tokenList_sortItemLabel " v-if="idx===1">
          {{$t('12925')}}
        </div>
        <div class="tokenList_sortItemLabel " v-if="idx===2">
          {{$t('12926')}}
        </div>
        <span  :class="['tokenList_sortIcon',clickItem===idx?className:'']"  >
            <a-icon type="caret-up" />
            <a-icon type="caret-down" />
        </span>
      </div>
    </div>


    <div class="tokenList_tokenList">
      <a-layout id="components-layout-demo-fixed-sider"  v-show="!loading">
        <a-layout-sider :style="{ overflow: 'auto', height: 'calc(100% - 195px)' ,maxWidth:'300px', width:'100%',position: 'fixed', left: 0 ,background: 'transparent'}">
          <ul v-show="list.length!==0">
            <li :class="['tokenList_sortRow',i.symbol.toLowerCase()===symbol?'active':'']" v-for="i in list" :key="i.symbol"  @click="bitLogin(i)" >
              <div class="tokenList_sortItem">{{i.baseAsset}}</div>
              <div class="tokenList_sortItem tokenPrice">{{i.askPrice|digits2(i.tickSize)}}</div>

              <div 
              :class="['tokenList_sortItem','tokenPer',
              Math.floor(((i.askPrice-i.openPrice)/i.openPrice*100)*100)/100>0?'green':'',
              Math.floor(((i.askPrice-i.openPrice)/i.openPrice*100)*100)/100<0?'red':'',
              Math.floor(((i.askPrice-i.openPrice)/i.openPrice*100)*100)/100===0?'nothing':'']"
               v-show="upDown===1">
                  <i v-show="Math.floor(((i.askPrice-i.openPrice)/i.openPrice*100)*100)/100>0" class=" green">+</i>{{(i.askPrice-i.openPrice)/i.openPrice*100|fixedNum(2)}}%
              </div>
              
              <div :class="['tokenList_sortItem','tokenPer',
              Math.floor(((i.askPrice-i.openPrice)/i.openPrice*100)*100)/100 >0?'red':'',
              Math.floor(((i.askPrice-i.openPrice)/i.openPrice*100)*100)/100 <0?'green':'',
              Math.floor(((i.askPrice-i.openPrice)/i.openPrice*100)*100)/100 ===0?'nothing':'']" v-show="upDown===0">
                <i v-show="Math.floor(((i.askPrice-i.openPrice)/i.openPrice*100)*100)/100 >0" class=" red">+</i>{{(i.askPrice-i.openPrice)/i.openPrice*100|fixedNum(2)}}%
              </div>
            </li>
          </ul>
            <template v-if="list.length===0">
        <div class="noresult">
          <img src='../../assets/noresult.png' />
          <p>No Data</p>
        </div>
      </template>
        </a-layout-sider>
      </a-layout>
            <a-spin size="large" v-show="loading" class="loading" />
      
    </div>
  </div>
</template>
<script>
import {mapGetters, mapState ,mapActions,} from "vuex";
import {bitLogin,bitScore} from '@/api/wiki'
import socket from "../../tradingview/api/socket";
import {filterSearch,trim} from '@/utils/baseFn/filter'

import { creatCompare ,creatCompare2,creatCompare3} from "@/utils/baseFn/filter";
export default {
  
name:'tokenList',

data() {
  return {
    isSearch:false,
    socket:null,
    lockReconnect:false,
    activeKey:'USDT',
    loading:true,
    searchInfo:'',
    sort: [0, 0, 0, 0,], // 币种，最新价， 涨幅，交易量  0=无排序，1=从高到底，2=从低到高
    tradeList:[],
    list:[],
    clickItem:0,
    className:'',
    listHeader :[
      {label:'交易对',id:1}, 
      {label:'价格',id:2}, 
      {label:'涨幅',id:3}, 
    ],
    }
},
computed: {
  ...mapState(['quoteAssetList','symbolList','baseAsset','trade','symbol','wsIsOp','country','upDown','quotePrecision','tradeActive','baseAssetList','quoteAsset']),
  ...mapGetters(['getSymbolList','getTokenCode','getSymbolTicker',])
},
watch: {

  getSymbolTicker(e){
    if(!this.isSearch){
      
      this.list=e||[]
      if(this.sort[1]===1){
        this.list.sort(creatCompare3('baseAsset',1))
      }else if(this.sort[1]===2){
        this.list.sort(creatCompare3('baseAsset',2))
      }else if(this.sort[2]===1){
        this.list.sort(creatCompare('askPrice',1))
      }else if(this.sort[2]===2){
        this.list.sort(creatCompare('askPrice',2))
      }else if(this.sort[3]===1){
        this.list.sort(creatCompare2('askPrice','openPrice',1))
      }else if(this.sort[3]===2){
        this.list.sort(creatCompare2('askPrice','openPrice',2))
      }
      this.loading=false
    }
  },
  trade:{
    immediate:true,
    handler(e){
      this.activeKey=e.split('/')[1]
    
    }
  },
  tradeActive:{
    immediate:true,
    handler(e){
      
      let list = this.symbolList.filter((item) => {
      return item.quoteAsset===e
    }) ||[]
    this.setBaseAssetList({baseAssetList:list})
    }
  },

  symbolList:{
    immediate:true,
    handler(e){
      let list = e.filter((item) => {
      return item.quoteAsset===this.tradeActive
    }) ||[]
    this.setBaseAssetList({baseAssetList:list})
    }

  },
  symbol(newData,oldData){
    this.unSubscribe(oldData,20)
    this.unSubscribe(oldData,'')
    this.setAsks({asks:[]})
    this.setBids({bids:[]})
    this.setAsksDep({asksDep:[]})
    this.setBidsDep({bidsDep:[]})
    this.subscribe(newData,20)
    this.subscribe(newData,'')
  },
  country:{
    immediate:true,
    handler(e){
      if(e!==''){
        this.initWs(e)
        this.subscribe(this.symbol,20)
        this.subscribe(this.symbol,'')
        // this.bitScore(e)
      }
    }
  },
},
mounted() {
  if(this.trade){

    this.setTradeActive({tradeActive:this.trade.split('/')[1]})
  }else{
    this.setTradeActive({tradeActive:'USDT'})
    
  }
},
methods: {
  ...mapActions(['setTradeActive','setBaseAsset','setScore','setTrade','setAsks','setBids','setAsksDep','setBidsDep','setFix','setTradeList','setDepthData','setWsIsOp','setTokenCode','setQuoteasset','setBaseAssetList','setQp']),
  checkTrade(e){
    this.loading=true
    this.searchInfo=''
    this.isSearch=false
    this.activeKey=e
    this.setTradeActive({tradeActive:e})
  },
  handleMenuClick(e) {
    this.loading=true
    this.searchInfo=''
    this.isSearch=false
    this.activeKey=e.key
    this.setTradeActive({tradeActive:e.key})
  },
  bitLogin(data){
    
    this.setQuoteasset({quoteAsset:data.quoteAsset})
    if(this.symbol!==data.symbol.toLowerCase()){
      this.setBaseAsset({baseAsset:data.baseAsset})
      this.setTrade({trade:data.baseAsset})
      bitLogin().then(res=>{
        localStorage.setItem('TOKEN',res.access_token)
        this.bitScore(this.country)
    })
    }
    let token1=this.getTokenCode
    this.$router.replace({ params: { token2: data.quoteAsset ,token1:token1+'.html'}})
  },
  
  getStar (kbscore) {
    if (!kbscore) return 0
    const sta = Number(kbscore).toFixed(2)
    if (sta < 1) return 0
    else if (sta > 1 && sta <= 1.25) return 1
    else if (sta >= 1.26 && sta <= 1.75) return 1.5
    else if (sta >= 1.76 && sta <= 2.25) return 2
    else if (sta >= 2.26 && sta <= 2.75) return 2.5
    else if (sta >= 2.76 && sta <= 3.25) return 3
    else if (sta >= 3.26 && sta <= 3.75) return 3.5
    else if (sta >= 3.76 && sta <= 4.25) return 4
    else if (sta >= 4.26 && sta <= 4.75) return 4.5
    else if (sta >= 4.76 && sta <= 5) return 5
  },
  bitScore(country){
      let evaluationCode=this.getTokenCode
      this.setTokenCode({TokenCode:evaluationCode})
      bitScore(evaluationCode,country).then(res=>{
      let   {Data} = res
      console.log(this.getStar(Data.result.kbscore));
      this.setScore({score:this.getStar(Data.result.kbscore)})
        // this.setScore({score:Data.result.score})
      })
  },
  // 输入框的值变化时
  onSearch(e) {
    const inputVal = trim(e.target.value)
      if(inputVal){
        this.isSearch=true
        let list = filterSearch({
          search: inputVal,
          oldList: this.getSymbolTicker
        });
        this.list=list
      }else{
        this.isSearch=false
      }

  },
  handleButtonClick(e) {
      // console.log('click left button', e);
  },
  changeSort(idx){
    this.loading=true
    if(this.list.length==0){
      this.loading=false
    }

      for (let i = 0; i < this.sort.length; i++) {
        if (i !== idx) {
          this.sort[i] = 0;
        }
      }
      this.sort[idx] = this.sort[idx] + 1 > 2 ? this.sort[idx] = 0 : ++this.sort[idx];
      this.clickItem=idx-1
      if (this.sort[idx] === 1) {
        this.className = 'asc';
      } else if (this.sort[idx] === 2) {
        this.className = 'desc';
      }else{
        this.className=''
      }
  },
  
  initWs(e){
      this.socket= new socket(e)
      this.socket.doOpen();
      this.socket.onClose=this.websocketOnclose;
      this.socket.onError=this.websocketOnerror;
      this.socket.onMessage = this.websocketOnmessage;
      
    },
      websocketOnmessage(e){
        if(e.stream){

          let str=e.stream.split('@')[1]
          if(str==='depth20'){
              let a=e.data.asks
              let b=e.data.bids
              let fix_a=0
              let fix_b=0
              a.map((item,i)=>{
                if(!a[0][2]){
                  item.push(item[1])
                }else{
                  item.push(+a[i-1][2]+(+item[1]))
                }
                fix_a=fix_a+Number(item[1])
              })
              b.map((item,i)=>{
                if(!b[0][2]){
                  item.push(item[1])
                }else{
                  item.push(+b[i-1][2]+(+item[1]))
                }
                fix_b=fix_b+Number(item[1])
              })
              fix_a = a.length ? fix_a / a.length : 0;
              fix_b = b.length ? fix_b / b.length : 0;
              
              let fix = (Number(fix_a) + Number(fix_b)) / 2;
              // console.log(fix);
              this.setFix({fix:fix})
              this.setAsks({asks:a.reverse()})
              this.setBids({bids:b}) 
              // this.setDepthData({depthData:e.data})
          }else if(str==='depth'){
              let a=e.data.a
              let b=e.data.b.reverse()
              let fix_a=0
              let fix_b=0
              a.map((item,i)=>{
                if(!a[0][2]){
                  item.push(item[1])
                }else{
                  item.push(+a[i-1][2]+(+item[1]))
                }
                fix_a=fix_a+Number(item[2])
              })
              b.map((item,i)=>{
                if(!b[0][2]){
                  item.push(item[1])
                }else{
                  item.push(+b[i-1][2]+(+item[1]))
                }
                fix_b=fix_b+Number(item[2])
      
              })
              fix_a = a.length ? fix_a / a.length : 0;
              fix_b = b.length ? fix_b / b.length : 0;
              
              let fix = (Number(fix_a) + Number(fix_b)) / 2;
              // console.log(fix);
              // this.setFix({fix:fix})
              this.setAsksDep({asksDep:a.reverse()})
              this.setBidsDep({bidsDep:b}) 
  
  
              // this.setDepthData({depthData:e.data})
  
          }
        }
    },
    subscribe(data,limit) {
      let params = {
        id:1,
        method: "SUBSCRIBE",
        params:[ `${data}@depth${limit}@1000ms`]
      }
      this.sendMessage(JSON.stringify(params));
    },
    unSubscribe(data,limit) {
      // 停止订阅，删除过期缓存、缓存时间、缓存状态
      let params = {
        id:1,
        method: "UNSUBSCRIBE",
        params:[ `${data}@depth${limit}@1000ms`]

      }
      this.sendMessage(JSON.stringify(params));
    },
    sendMessage(data){
      this.setWsIsOp({wsIsOp:this.socket.checkOpen()})
    if (this.socket.checkOpen()) { //检验websocket是否打开
      this.socket.send(data);
    } else {
      this.socket.send(data);
      this.socket.on('open', () => {
      this.setWsIsOp({wsIsOp:this.socket.checkOpen()})
        this.socket.send(data);
      });
    }
    },
    websocketOnerror() {
      console.log("WebSocket连接发生错误");
      this.reconnect();
    },
    websocketOnclose(e) {
      console.log("connection closed (" + e.code + ")");
      this.reconnect();
    },
    reconnect() {
      let that = this;
      if(that.lockReconnect) return;
      that.lockReconnect = true;
      setTimeout(function () {
      that.socket.destroy()
      that.initWs(that.country);
      that.subscribe(that.symbol,20)
      that.subscribe(that.symbol,'')
      that.lockReconnect = false;
      }, 500);
    },
},
beforeDestroy () {
 
  this.unSubscribe(this.symbol,20)
  this.unSubscribe(this.symbol,'')
  this.socket.destroy();
  
},
}
</script>

<style lang="less" >
.tokenList{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: var(--fontWhite);
    background: var(--grey800);
    
    .noresult {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 152px 0 0;
      color: var(--grey300);
      font-size: 14px;
      line-height: 20px;
   
      & img {
        width: 40px;
        height: 40px;
      }
      & p {
        margin: 16px 0 0;
      }
    }
    .tokenList_tabs{
      position: relative;
      .ant-btn:first-child{
        display: none;
      }
       .ant-btn-default{
        
        position: absolute;
        right: -130px;
        top: 7px;
        z-index: 999;
        background-color: var(--grey800);
        color: var(--fontWhite);
        border:none;
      }
    }
    // .ant-tabs-nav-scroll {
    //  padding-left: 10px;
    // }
     .ant-tabs{
      margin: 0 0px 0 20px;
      padding-left: 5px;
      height: 46px;
      .ant-tabs-tab{
        padding: 6px 6px;
        color: var(--grey200);
        cursor: pointer;
      }
      .ant-tabs-nav{
      margin: 0px 0 8px 0px;
        &::before {
        // display: none;
      }
      }
      .ant-tabs-nav .ant-tabs-tab{
        margin: 0 20px 0px 0px ;
      }
       .ant-tabs-tab-arrow-show{
        // display: none;
       }
       .ant-tabs-tab-prev.ant-tabs-tab-arrow-show{
        width: 10px;
       }
       .ant-tabs-tab-prev-icon{
        position: absolute;
        margin-right: 20px;
        top: 16px;
        left: 3px;
        color: var(--grey200);
       }
       .ant-tabs-tab-next.ant-tabs-tab-arrow-show{
        display: none;
       }
       .ant-tabs-tab-next-icon{
        display: none;
       }
       .ant-tabs-nav-container-scrolling{
        padding: 0 0px 0 10px;
        margin: 0 43px 0 0;
       }

      .ant-tabs-tab-active{
        color: var(--active);
       }
      .ant-tabs-nav .ant-tabs-tab:hover {
        color: var(--active);
      }
      .ant-tabs-ink-bar{
        background-color: var(--active);
      }
  
    }
    
    .tokenList_searchBox{
      margin: 0 8px 8px 16px;
    }
     .ant-input-affix-wrapper {
      .ant-input-prefix {
        color: var(--fontWhite);
      }
      input {
        background: transparent;
      }
      .ant-input {
          color: var(--fontWhite);
          border-color: #475563;
      }
      .ant-input:hover{
        border-color: #475563;
        // border-color: #FFC300;
      }
      .ant-input:focus{
        border-color: #FFC300;
      }
      .anticon.ant-input-clear-icon{
        color: var(--grey500);
      }
    }

    .tokenList_tHeader {
      display: flex;
      margin: 0 8px 0 16px;
      font-size: 12px;
      .tokenList_sortItem {
        justify-content: space-between;
        height: 24px;
        line-height: 24px;
      }
    }
      .tokenList_sortIcon.desc{
        i:nth-child(1){
          color: var(--active);
        }
      }
      
      .tokenList_sortIcon.asc{
        i:nth-child(2){
          color: var(--active);
        }
      }
        
    .tokenList_sortItem {
      display: flex;
      // color: #fff;
      color: var(--grey200);
      &:nth-child(1) {
        flex: 90 1 0px;
        justify-content: flex-start;
        min-width: 120px;
      }
      &:nth-child(2) {
        flex: 80 1 0px;
        min-width: 60px;
        justify-content: flex-start;
      }
      &:nth-child(3) {
        flex: 65 1 0px;
        min-width: 65px;
        justify-content: flex-end;
      }
      .tokenList_sortItemLabel {
        color: var(--grey300);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        user-select: none;
        cursor: pointer;
      }
    }
    .tokenList_sortIcon {
      display: flex;
      color: var(--grey300);
      flex-direction: column;
      justify-content: center;
      margin-left: 2px;
      font-size: 10px;
      .anticon {
        height: 8px;
        &:nth-child(1) {
          margin-top: -1px;
        }
        &:nth-child(1) {
          margin-bottom: -1px;
        }
      }
    }
    .tokenList_tokenList {
      position: relative;
      flex: 1;
      scrollbar-width: thin;
      scrollbar-color: rgba(127, 143, 164, 0.6) rgba(0, 0, 0, 0.2) ;
      .ant-empty{
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%,-50%);
        // color: #475563;
      }
    .loading{
          // flex: ;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
    }
    .tokenList_sortRow {
      display: flex;
      padding: 0 8px 0 16px;
      font-size: 12px;
      line-height: 26px;
      color: var(--fontWhite);
      font-weight: 600;
      cursor: pointer;
      &.active {
        background: var(--rowBg);
      }
      &:hover {
        background: var(--rowBg);
      }
    }
    .tokenPrice {
      justify-content: right;
      text-align: left;
      color: var(--grey200);
    }
    .tokenPer {
      justify-content: right;
      min-width: 65px;
      color: var(--grey500);
      &.green{
        color: rgb(107, 185, 109);
      }
      &.red{
        color: rgb(236, 77, 92);
      }
      &.nothing{
        color: var(--grey200);
      }
      .green{
        color: rgb(107, 185, 109);
      }
      .red{
        color: rgb(236, 77, 92);
      }
    }
  }
  .ant-dropdown-menu{
      position: relative;
      max-height: 200px;
      overflow-x: hidden;
      overflow-y: auto;
      margin: 0;
      padding: 4px 0;
      text-align: left;
      list-style-type: none;
      background-color: #fff;
      background-clip: padding-box;
      border-radius: 4px;
      outline: none;
      box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
      -webkit-transform: translate3d(0, 0, 0);
      scrollbar-width: none;
      scrollbar-color: rgba(127, 143, 164, 0.6) rgba(0, 0, 0, 0.2) ;
    }

    
  .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title{
     min-width: 120px;
     margin: 0;
     padding: 5px 12px;
     overflow: hidden;
     color: rgba(0,0,0,.85);
     font-weight: 400;
     font-size: 14px;
     line-height: 22px;
     white-space: nowrap;
     text-overflow: ellipsis;
     cursor: pointer;
     transition: all .3s;
   }

</style>